<template>
  <Modal :value="isShow" class="bqModalBox" @on-cancel="cancelHandle" :mask-closable="false" class-name="vertical-center-modal">
    <span slot="header">企业FTA诊断申请</span>
    <div class="modal-content">
      <div class="modal-content-wrap">
        <div class="coo">
          <Form ref="form" :model="form" :rules="ruleForm" @submit.native.prevent>
            <FormItem prop="company" label="公司名称">
              <Input type="text" v-model.trim="form.company" placeholder="请填写公司名称"/>
            </FormItem>
            <FormItem prop="name" label="联系人姓名">
              <Input type="text" v-model.trim="form.name" placeholder="请填写联系人姓名"/>
            </FormItem>
            <FormItem prop="mobile" label="联系人电话">
              <Input type="text" v-model.trim="form.mobile" placeholder="请填写联系人电话"/>
            </FormItem>
            <FormItem prop="email" label="联系人邮箱" placeholder="请填写联系人邮箱">
              <Input type="text" v-model.trim="form.email"/>
            </FormItem>
            <FormItem prop="resource" class="resource_item">
              <span class="resource_label" slot="label">
                <span>查询附件</span>
                <a href="https://hifun-test.oss-cn-shanghai.aliyuncs.com/otech/%E6%89%B9%E9%87%8F%E6%9F%A5%E8%AF%A2%E6%95%B0%E6%8D%AE%E6%A8%A1%E6%9D%BF.xlsx" traget="_blank">（模板下载）</a>
              </span>
              <div class="upload" @click.prevent="upload">
                <div class="upload-wrap">
                  <i class="form-icon portrait"></i>
                  <div class="upload-content"><span class="placeholder">{{uploadText}}</span></div>
                  <div class="process" :style="`width:${process.width}%`" v-show="isUploading"></div>
                  <div class="proces-test" v-show="isUploading">{{$t('common.uploading')}} {{process.value}}%</div>
                  <Spin fix v-show="isUploading">
                    <Icon type="load-c" size="15" class="spin-icon-load"></Icon>
                  </Spin>
                  <i class="add-icon" v-show="!isUploading"></i>
                </div>
              </div>
              <input type="file" ref="fileInput" @change="fileChange($event)" class="upload-input">
            </FormItem>
          </Form>
        </div>
        <div class="footer">
          <div class="footer-wrap clearfix">
            <div class="btn" @click.prevent="okHandle">确定</div>
          </div>
        </div>
      </div>
    </div>
    <div slot="footer"></div>
  </Modal>
</template>

<script>
export default {
  name: 'BatchQueryModal',
  props: {
    isShow: {
      type: Boolean,
      default: false,
      required: false
    },
    dataSet: {
      type: Object,
      default: () => { return {} },
      required: false
    }
  },
  data () {
    const phoneCheck = (rule, value, callback) => {
      if (value && (!(this._h.isPhoneNumber(value) || this._h.isTelNumber(value)))) {
        callback(new Error(this.$t('account.reg.phoneMsg')))
      } else {
        callback()
      }
    }
    return {
      isSubmit: false,
      isUploading: false,
      process: { value: 0, width: 0 },
      form: {
        company: null,
        name: null,
        mobile: null,
        email: null,
        resource: null
      },
      ruleForm: {
        // company: [
        //   { required: true, message: '请填写公司名称', trigger: 'blur' }
        // ],
        name: [
          { required: true, message: '请填写联系人姓名', trigger: 'blur' }
        ],
        mobile: [
          { required: true, message: '请填写联系人电话', trigger: 'blur' },
          { validator: phoneCheck, trigger: 'blur' }
        ],
        email: [
          // { required: true, message: '请填写联系人邮箱', trigger: 'blur' },
          { type: 'email', message: this.$t('account.reg.emailMsg'), trigger: 'blur' }
        ],
        resource: [
          { required: true, message: '请上传附件', trigger: 'blur' }
        ]
      }
    }
  },
  watch: {
    dataSet (newVal, oldVal) {
      if (newVal && newVal.mobile) {
        this.form = this._.assign(this.form || {}, {company: newVal.company || '', name: newVal.name || '', mobile: newVal.mobile || '', email: newVal.email || ''})
      }
    }
  },
  computed: {
    uploadText () {
      if (this.isUploading) {
        return '请上传附件'
      } else {
        if (this.form.resource) {
          return '重新上传附件'
        } else {
          return '请上传附件'
        }
      }
    }
  },
  methods: {
    okHandle (event) {
      if (this.form.resource) {
        this.$refs['form'].validate((valid) => {
          if (valid) {
            if (!this.isSubmit) {
              this.$api.batchQuery.submit(this.form, {
                success: response => {
                  this.$Message.destroy()
                  if (response.data.code === 200) {
                    this.$Message.success({
                      content: '申请成功，请等待',
                      closable: true,
                      onClose: () => {
                        this.$parent.ApplyOk()
                        this.$emit('changeState', false)
                        this.isSubmit = false
                      }
                    })
                  } else {
                    this.$Message.warning({content: '提交失败，请重试！', closable: true})
                    this.isSubmit = false
                  }
                },
                error: errorMsg => {
                  this.isSubmit = false
                  this.$Message.error({content: this.$t('common.tryAgain'), closable: true})
                }
              })
            }
          }
        })
      } else {
        this.$Message.info('请上传附件')
      }
    },
    cancelHandle () {
      this.$emit('changeState', false)
    },
    uploadFileToAzure (file, sas, container, callback) {
      let fileName = this._h.getRandomStr(15)
      let suffix = this._h.getSuffix(file.name)
      let processValue = this._.random(36, 90)
      this.process.value = processValue
      this.process.width = processValue
      let intervalInst = setInterval(() => {
        processValue = this._.random(processValue, 98)
        this.process.value = processValue
        this.process.width = processValue
        if (processValue > 98) {
          clearInterval(intervalInst)
        }
      }, 300)
      let azureName = 'smartftax'
      let blobUri = `https://${azureName}.blob.core.chinacloudapi.cn`
      let blobService = this.$AzureStorage.createBlobServiceWithSas(blobUri, sas)
      blobService.createBlockBlobFromBrowserFile(container, `${fileName}${suffix}`, file, (error, result) => {
        intervalInst && clearInterval(intervalInst)
        if (!error) {
          this.$Loading.finish()
          this.process.value = 100
          this.process.width = 100
          if (callback && typeof callback === 'function') {
            callback(result)
          }
          this.form.resource = `${blobUri}/${container}/${fileName}${suffix}`
        } else {
          this.$Loading.error()
          this.$Message.error({content: this.$t('common.uploadError'), closable: true})
        }
        this.isUploading = false
        this.$refs.fileInput.value = null
        setTimeout(() => {
          this.process.value = 0
          this.process.width = 0
        }, 200)
      })
    },
    uploadFiles (files) {
      if (!files || files.length === 0) return
      let isRefused = false
      this._.each(files, (file) => {
        if (file.size > 20 * 1024 * 1024) {
          this.$Message.error({content: this.$t('common.uploadSizeError'), closable: true})
          isRefused = true
          return false
        }
        let suffix = this._h.getSuffix(file.name)
        if (this._.indexOf(['.xlsx', '.xls'], suffix) === -1) {
          this.$Message.error({content: this.$t('common.uploadTypeError'), closable: true})
          isRefused = true
          return false
        }
      })
      if (isRefused) {
        this.$refs.fileInput.value = null
        return
      }
      this.$Loading.start()
      this.isUploading = true
      let container = 'content'
      this.$api.getSasToken(container, {
        success: (response) => {
          if (response.data.code === 200) {
            this._.forEach(files, (file) => {
              let sas = response.data.data.sas
              this.uploadFileToAzure(file, sas, container)
            })
          } else {
            this.$Loading.error()
            this.$Message.error({content: this.$t('common.uploadSasError2'), closable: true})
            this.isUploading = false
            this.$refs.fileInput.value = null
          }
        },
        error: (errorMsg) => {
          this.$Loading.error()
          this.$Message.error({content: this.$t('common.uploadSasError'), closable: true})
          this.isUploading = false
          this.$refs.fileInput.value = null
        }
      })
    },
    upload () {
      if (!this.isUploading) {
        this.$refs.fileInput.click()
      }
    },
    fileChange (event) {
      const files = event.target.files
      if (!files || files.length === 0) return
      this.uploadFiles(files)
    }
  }
}
</script>
<style>
  @media print,screen and (min-width:1366px) {
    .bqModalBox .vertical-center-modal,
    .bqModalBox .ivu-modal{
      width: 320px !important;
      margin: 0 auto;
    }
    .bqModalBox .ivu-modal-close .ivu-icon-ios-close-empty{
      top: 0 !important;
    }
  }
  @media print,screen and (max-width:1365px) {
    .bqModalBox .vertical-center-modal,
    .bqModalBox .ivu-modal{
      width: 320px !important;
      margin: 0 auto;
    }
  }
  .bqModalBox .vertical-center-modal{
    display: flex;
    align-items: center;
    justify-content: center;
    margin: 0 auto;
    /*margin-top: -100px;*/
  }
  .bqModalBox .vertical-center-modal .ivu-modal{
    top: 0;
  }
  .bqModalBox .ivu-modal-header{
    font-weight: bold;
    font-size: 14px;
  }
  /*.bqModalBox .ivu-modal-header,*/
  .bqModalBox .ivu-modal-footer{
    display: none;
  }
  /*.bqModalBox .ivu-modal-close{*/
  /*display: none;*/
  /*}*/
  .bqModalBox .modal-content-wrap .title{
    text-align: center;
    font-size: 13px;
    color: #333;
    margin: 5px 0 12px;
  }
  .bqModalBox .guide img {
    width: 100%;
  }
  /* .bqModalBox .ivu-carousel-item img{
    width: 893px;
    height: 435px;
  } */
  .bqModalBox .footer{
    margin: 25px 0 15px;
  }
  .bqModalBox .footer .footer-wrap{
    position: relative;
    display: flex;
    justify-content: center;
    align-items: center;
  }
  .bqModalBox .footer .btn{
    background-image: linear-gradient(-90deg, #0F7EF3 0%, #27BEFE 100%);
    border-radius: 3px;
    font-size: 13px;
    color: #fff;
    height: 32px;
    line-height: 32px;
    /* width: 120px; */
    width: 100%;
    text-align: center;
    float: left;
    cursor: pointer;
  }
  .bqModalBox .footer .ivu-checkbox-wrapper{
    font-size: 12px;
    color: #999;
    padding-left: 15px;
  }
  .bqModalBox .ivu-input-wrapper .ivu-input-icon{
    line-height: 32px !important;
    width: 32px;
    height: 32px;
  }
</style>
<style scoped>
  .ivu-form >>> .resource_item{
    margin-top: 12px;
  }
  .ivu-form >>> .resource_item .ivu-form-item-label{
    position: relative;
    width: 100%;
    display: block;
    text-align: left;
  }
  .ivu-form >>> .resource_item .resource_label a{
    /* position: absolute;
    right: 3px;
    top: 50%;
    transform: translateY(-50%); */
    font-size: 12px;
    /* text-decoration: underline; */
  }
  /* .ivu-form >>> .resource_item .resource_label a:hover{
    text-decoration: none;
  } */
  .ivu-form >>> .ivu-form-item-label{
    float: none;
    padding: 0;
  }
  .ivu-form >>> .ivu-form-item-content{
    margin-top: 5px;
  }
  .ivu-form >>> .ivu-form-item-required .ivu-form-item-label::before{
    content: '';
  }
  .ivu-form-item >>> .ivu-select.ivu-select-multiple .ivu-select-input,
  .ivu-form-item >>> .ivu-select.ivu-select-multiple .ivu-select-placeholder{
    padding-left: 0;
  }
  .ivu-form-item.authcode >>> .ivu-form-item-content{
    border: 0.5px solid #DBDBDB;
    border-radius: 2px;
  }
  .ivu-form-item.authcode >>> .ivu-form-item-content .ivu-input-group{
    top:0;
  }
  .ivu-form-item.authcode >>> .ivu-form-item-content .ivu-input-group-prepend{
    width: 25px;
    height: auto;
    /*border-top-left-radius: 2px;*/
    /*border-bottom-left-radius: 2px;*/
    /*position: relative;*/
    background-color: transparent;
    border: 0 none;
  }
  .ivu-form-item.authcode >>> .ivu-form-item-content .ivu-input-group-prepend i{
    background: url("~@/assets/images/icons/account/authcode.png") 5px center no-repeat transparent;
    background-size: 8px auto;
    width: 15px;
    height: 100%;
    display: block;
    position: absolute;
    /*top: 0;*/
    top: 50%;
    transform: translateY(-50%);
    left: 4px;
  }
  .ivu-form-item.authcode >>> .ivu-form-item-content .ivu-input-group-append{
    background-color: #2681FF;
    color: #fff;
    border-top-right-radius: 2px;
    border-bottom-right-radius: 2px;
    /*border-radius: 0;*/
    /*font-size: 1rem;*/
    font-size: 1.2rem;
    border: 0 none;
    /*border: 0.5px solid #DBDBDB;*/
    cursor: pointer;
    padding: 4px 12px;
  }
  .ivu-form-item.authcode >>> .ivu-form-item-content .ivu-input{
    border-left: 0 none;
    border: 0 none;
    padding-left: 0;
    outline: none;
    transition: all 0 ease 0;
    margin: 2px 0;
  }
  .ivu-form-item.authcode >>> .ivu-form-item-content .ivu-input:focus{
    border-color: transparent;
    box-shadow: none;
  }
  .ivu-form-item{
    margin-bottom: 10px;
  }
  .ivu-form-item.ivu-form-item-error{
    margin-bottom: 25px;
  }
  .ivu-form-item >>> .ivu-input-disabled{
    background-color: transparent;
  }
  .form-icon{
    background: url("~@/assets/images/icons/account/uid.png") 0 0 no-repeat transparent;
    width: 11px;
    height: 10px;
    background-size: auto 10px;
    z-index: 1;
    position: absolute;
    top: 50%;
    left: 10px;
    transform: translateY(-50%);
    margin-top: 0.5px;
  }
  .form-icon.portrait{
    background-image: url("~@/assets/images/icons/member/icon_wddh.png");
  }
  .ivu-form >>> .ivu-form-item-required .ivu-form-item-label::after,
  .gender_item >>> .ivu-form-item-label::after{
    content: '*';
    display: inline-block;
    margin-left: 4px;
    line-height: 1;
    font-family: SimSun;
    font-size: 12px;
    color: #ed3f14;
  }
  .upload{
    border: 0.5px solid #DBDBDB;
    height: 32px;
    line-height: 32px;
    border-radius: 2px;
    /*padding-left: 25px;*/
    /*padding-right: 24px;*/
    position: relative;
    cursor: pointer;
  }
  .upload-wrap{
    padding-left: 25px;
    padding-right: 24px;
    position: absolute;
    top:0.5px;
    left:0.5px;
    bottom: 0.5px;
    right: 0.5px;
  }
  .upload .upload-content{
    position: relative;
    top: -1px;
  }
  .upload .upload-content .placeholder{
    /*font-size: 10px;*/
    font-size: 12px;
    color: #999;
  }
  .upload .process{
    position: absolute;
    top:0;
    bottom: 0;
    left:0;
    width: 0;
    transition: width 0.3s;
    /*background-color: #2DB7F5;*/
    background-color: rgba(45, 183, 245, 0.2);
    z-index: 10;
  }
  .upload .proces-test{
    position: absolute;
    top:0;
    bottom: 0;
    left:0;
    right: 0;
    z-index: 101;
    /*font-size: 10px;*/
    font-size: 12px;
    color: #333;
    text-align: center;
  }
  .upload .add-icon{
    background-image: url("~@/assets/images/icons/account/add.png");
    background-size: auto 10px;
    width: 10px;
    height: 10px;
    position: absolute;
    right: 7px;
    top: 50%;
    transform: translateY(-50%);
  }
  .upload >>> .ivu-spin-main{
    left: auto;
    right: 1px;
  }
  .upload >>> .ivu-spin .spin-icon-load{
    position: relative;
    top: 1px;
  }
  .spin-icon-load{
    animation: ani-demo-spin 1s linear infinite;
  }
  @keyframes ani-demo-spin {
    from { transform: rotate(0deg);}
    50%  { transform: rotate(180deg);}
    to   { transform: rotate(360deg);}
  }
  .upload-input{
    display: none;
  }
  .other_formitem_class >>> .ivu-form-item-error-tip{
    margin-top: 10px !important;
  }
  @media print,screen and (min-width:1366px) {
    .ivu-form >>> .ivu-form-item-label{
      font-size: 14px;
    }
    .ivu-form >>> .ivu-input{
      font-size: 14px;
    }
    .upload .upload-content .placeholder{
      font-size: 14px;
    }
    .bqModalBox >>> .footer .btn{
      font-size: 15px;
    }
  }
</style>



// WEBPACK FOOTER //
// src/components/batchQuery/zh-CN/Modal.vue